import { combineReducers } from "@reduxjs/toolkit";

import {
	globalStateDispatcherRateDataState,
	globalStateDispatcherRateDataReducer,
	globalStateDispatcherRateDataAction,
} from "./data";

export type StateDispatcherRate = {
	data: globalStateDispatcherRateDataState;
};

export const dispatcherRate = combineReducers<StateDispatcherRate>({
	data: globalStateDispatcherRateDataReducer,
});

export const globalStateDispatcherRateAction = {
	data: globalStateDispatcherRateDataAction,
};

export default dispatcherRate;
